"use client";
import { feedbackType } from "@/db/feedbackDataThree";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import FeedbackTwoCard from "./feedbackCard";

import "swiper/css";
import "swiper/css/pagination";

const FeedbackTwo = ({
  feedbackDataTwo,
}: {
  feedbackDataTwo: feedbackType[];
}) => {
  return (
    <div className="testimonials-container">
      <Swiper
        spaceBetween={25}
        loop
        slidesPerGroup={3}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 3 },
          1600: { slidesPerView: 4 },
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={2500}
        pagination={{
          clickable: true,
          el: ".pagination-el",
        }}
        modules={[Autoplay, Pagination]}
        className="testimonials-slides"
        data-cue="slideInUp"
      >
        {feedbackDataTwo.map((testimonial, idx) => (
          <SwiperSlide key={idx}>
            <div >
              <FeedbackTwoCard testimonial={testimonial} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="pagination-el"></div>
    </div>
  );
};

export default FeedbackTwo;
